export const FILTERS = [
    { key: "New", label: "New", count: 0 },
    { key: "Pending", label: "Pending", count: 0 },
    { key: "Confirmed", label: "Confirmed", count: 0 },
    { key: "Canceled", label: "Canceled", count: 0 },
    { key: "All", label: "All", count: 0 },
];

export const TRANSLATION_MAP = {
    All: "all",
    New: "new",
    Pending: "pending",
    Confirmed: "confirmed",
    Completed: "completed",
    Canceled: "canceled",
    Delivered: "delivered",

};

export const getStatus = (reservationStatus) => {
    if (reservationStatus.canceled) return "Canceled";
    if (reservationStatus.confirmed) return "Confirmed";
    if (reservationStatus.seen) return "Pending";
    return "New";
}
